export const styles = {
  wrapper: {
    display: 'flex',
    top: 24,
    position: 'sticky',
    height: 'max-content',
    flexDirection: 'column',
  },
  wrapperBigCard: {
    margin: '10px 0',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/BigCardsBlock/styles.js